// Pure helpers for grouping Pre-Market deals into year sections.
// No React, no Firestore.
//
// Listings are grouped by the year of their "Target Date / Coming Soon Date",
// which is stored on the deal as `listingAppointment` (an ISO "YYYY-MM-DD"
// string set from the seller form's "Target Date/Coming Soon Date" field).
const DATE_FIELD = "listingAppointment";

function _parseYear(iso) {
  if (typeof iso !== "string") return null;
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  const y = Number(m[1]);
  return Number.isNaN(y) ? null : y;
}

function _time(iso) {
  // Sortable timestamp; missing/invalid sorts last.
  if (typeof iso !== "string") return Infinity;
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return Infinity;
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])).valueOf();
}

function groupPreMarketByYear(deals, currentYear) {
  const list = Array.isArray(deals) ? deals : [];
  const cy =
    typeof currentYear === "number" ? currentYear : new Date().getFullYear();

  const byYear = new Map(); // year -> deals[]
  const noDate = [];
  for (const d of list) {
    const y = _parseYear(d && d[DATE_FIELD]);
    if (y === null) {
      noDate.push(d);
      continue;
    }
    if (!byYear.has(y)) byYear.set(y, []);
    byYear.get(y).push(d);
  }

  const sections = [...byYear.keys()]
    .sort((a, b) => a - b)
    .map((year) => ({
      key: String(year),
      label: String(year),
      year,
      deals: byYear
        .get(year)
        .slice()
        .sort((a, b) => _time(a[DATE_FIELD]) - _time(b[DATE_FIELD])),
      defaultOpen: year <= cy, // current + past open, future collapsed
    }));

  if (noDate.length) {
    sections.push({
      key: "no-date",
      label: "No Date",
      year: null,
      deals: noDate
        .slice()
        .sort((a, b) => Number(a.createdat || 0) - Number(b.createdat || 0)),
      defaultOpen: false,
    });
  }
  return sections;
}

function formatBoardDate(iso) {
  if (typeof iso !== "string") return "";
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return "";
  const date = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  if (Number.isNaN(date.valueOf())) return "";
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

module.exports = { groupPreMarketByYear, formatBoardDate };
